import { guessCountry as guessFrom, type Country } from '@zip2live/shared/contact';

export * from '@zip2live/shared/contact';

/** Best guess from this browser's languages, e.g. en-GB → GB. Falls back to US. */
export function guessCountry(): Country {
  return guessFrom(navigator.languages ?? [navigator.language]);
}
